/* ================================================================
   HOA CART DRAWER — cart-drawer.js
   Vanilla JS, kein jQuery, keine externen Libraries.
   Shopify AJAX Cart API: /cart/add.js, /cart.js, /cart/change.js
   ================================================================ */
(function () {
  'use strict';

  var SHIPPING_THRESHOLD = 5000; /* 50 € in Cent */

  var CartDrawer = {
    drawer:    null,
    backdrop:  null,
    closeBtn:  null,
    triggerEl: null,

    init: function () {
      this.drawer   = document.getElementById('hoa-cart-drawer');
      this.backdrop = document.getElementById('hoa-cart-backdrop');
      this.closeBtn = document.getElementById('hoa-cart-close');

      if (!this.drawer) return;

      /* Cart-Icon im Header */
      document.querySelectorAll('[data-hoa-cart-open]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          CartDrawer.triggerEl = el;
          CartDrawer.open();
        });
      });

      /* Schließen-Button */
      this.closeBtn.addEventListener('click', function () {
        CartDrawer.close();
      });

      /* Backdrop-Klick schließt */
      this.backdrop.addEventListener('click', function () {
        CartDrawer.close();
      });

      /* Escape-Taste schließt */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && CartDrawer.isOpen()) {
          CartDrawer.close();
        }
      });

      /* Delegiertes Add-to-Cart */
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-hoa-add-to-cart]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        /* data-qty wird von product-page.js gesetzt wenn Menge > 1 */
        var qty = parseInt(btn.getAttribute('data-qty') || '1', 10) || 1;
        CartDrawer.addItem(variantId, qty, btn);
      });
    },

    isOpen: function () {
      return this.drawer.classList.contains('hoa-cart-drawer--open');
    },

    open: function () {
      CartDrawer.fetchAndRender(function () {
        CartDrawer.drawer.classList.add('hoa-cart-drawer--open');
        CartDrawer.drawer.setAttribute('aria-hidden', 'false');
        CartDrawer.backdrop.classList.add('hoa-cart-backdrop--open');
        CartDrawer.backdrop.setAttribute('aria-hidden', 'false');
        document.body.classList.add('hoa-drawer-open');
        CartDrawer.closeBtn.focus();
      });
    },

    close: function () {
      this.drawer.classList.remove('hoa-cart-drawer--open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.backdrop.classList.remove('hoa-cart-backdrop--open');
      this.backdrop.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hoa-drawer-open');
      if (this.triggerEl) {
        this.triggerEl.focus();
        this.triggerEl = null;
      }
    },

    /* ── AJAX HELPERS ─────────────────────────────────────────── */

    fetchAndRender: function (callback) {
      fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          CartDrawer.render(cart);
          if (callback) callback();
        })
        .catch(function (err) {
          console.warn('[HOA Cart] fetchAndRender Fehler:', err);
          if (callback) callback();
        });
    },

    addItem: function (variantId, qty, btn) {
      var origHTML = btn.innerHTML;
      btn.innerHTML = '<svg class="hoa-spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke-opacity="0.25"/><path d="M12 3a9 9 0 0 1 9 9" /></svg>';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          btn.textContent = '✓ Hinzugefügt';
          setTimeout(function () {
            btn.innerHTML = origHTML;
            btn.disabled = false;
          }, 1800);
          CartDrawer.triggerEl = btn;
          CartDrawer.open();
        })
        .catch(function () {
          btn.innerHTML = origHTML;
          btn.disabled = false;
        });
    },

    updateQuantity: function (line, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { CartDrawer.render(cart); })
        .catch(function (err) { console.warn('[HOA Cart] updateQuantity Fehler:', err); });
    },

    /* ── RENDER ───────────────────────────────────────────────── */

    render: function (cart) {
      this.renderCount(cart.item_count);
      this.renderShipping(cart.total_price);
      this.renderItems(cart);
      this.renderUpsell(cart);
      this.renderFooter(cart);
    },

    renderCount: function (count) {
      /* Zahl im Drawer-Titel */
      var titleCount = document.getElementById('hoa-cart-count');
      if (titleCount) titleCount.textContent = count;

      /* Badge im Header */
      var badge = document.querySelector('.hoa-hdr__cart-badge');
      if (badge) {
        badge.textContent = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      }
    },

    renderShipping: function (totalPrice) {
      var el = document.getElementById('hoa-cart-shipping');
      if (!el) return;

      if (totalPrice >= SHIPPING_THRESHOLD) {
        el.innerHTML = '<p class="hoa-cart-shipping__reached">🚚 Du hast kostenlosen Versand!</p>';
      } else {
        var remaining = ((SHIPPING_THRESHOLD - totalPrice) / 100)
          .toFixed(2)
          .replace('.', ',');
        var pct = Math.min(100, Math.round((totalPrice / SHIPPING_THRESHOLD) * 100));
        el.innerHTML =
          '<p class="hoa-cart-shipping__text">Noch <strong>' + remaining + '€</strong> bis kostenloser Versand</p>' +
          '<div class="hoa-cart-shipping__bar-wrap">' +
            '<div class="hoa-cart-shipping__bar-fill" style="width:' + pct + '%"></div>' +
          '</div>';
      }
    },

    renderItems: function (cart) {
      var el = document.getElementById('hoa-cart-items');
      if (!el) return;

      if (!cart.items || cart.items.length === 0) {
        el.innerHTML =
          '<div class="hoa-cart-empty">' +
            '<span class="hoa-cart-empty__icon" aria-hidden="true">🛒</span>' +
            '<p class="hoa-cart-empty__title">Dein Warenkorb ist leer</p>' +
            '<p class="hoa-cart-empty__sub">Schau dich um – wir haben was für jeden Anime-Fan.</p>' +
            '<a href="/collections/all" class="hoa-cart-empty__btn">Zur Kollektion</a>' +
          '</div>';
        return;
      }

      var html = '';
      cart.items.forEach(function (item, idx) {
        var line  = idx + 1;
        var price = (item.price / 100).toFixed(2).replace('.', ',');
        var img   = item.image
          ? '<img src="' + item.image + '" alt="' + CartDrawer.escape(item.product_title) + '" width="80" height="80" loading="lazy">'
          : '';
        var variant = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p class="hoa-cart-item__variant">' + CartDrawer.escape(item.variant_title) + '</p>'
          : '';

        html +=
          '<div class="hoa-cart-item" data-key="' + item.key + '">' +
            '<div class="hoa-cart-item__img-wrap">' + img + '</div>' +
            '<div class="hoa-cart-item__info">' +
              '<p class="hoa-cart-item__title">' + CartDrawer.escape(item.product_title) + '</p>' +
              variant +
              '<div class="hoa-cart-item__bottom">' +
                '<div class="hoa-cart-item__qty">' +
                  '<button class="hoa-cart-item__qty-btn" data-line="' + line + '" data-delta="-1" aria-label="Menge verringern">−</button>' +
                  '<span class="hoa-cart-item__qty-val">' + item.quantity + '</span>' +
                  '<button class="hoa-cart-item__qty-btn" data-line="' + line + '" data-delta="1"  aria-label="Menge erhöhen">+</button>' +
                '</div>' +
                '<p class="hoa-cart-item__price">' + price + '€</p>' +
              '</div>' +
            '</div>' +
            '<button class="hoa-cart-item__remove" data-line="' + line + '" aria-label="' + CartDrawer.escape(item.product_title) + ' entfernen">×</button>' +
          '</div>';
      });

      el.innerHTML = html;

      /* Quantity-Buttons binden */
      el.querySelectorAll('.hoa-cart-item__qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line    = parseInt(btn.getAttribute('data-line'), 10);
          var delta   = parseInt(btn.getAttribute('data-delta'), 10);
          var qtyEl   = btn.parentNode.querySelector('.hoa-cart-item__qty-val');
          var current = parseInt(qtyEl.textContent, 10);
          CartDrawer.updateQuantity(line, Math.max(0, current + delta));
        });
      });

      /* Remove-Buttons binden */
      el.querySelectorAll('.hoa-cart-item__remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          CartDrawer.updateQuantity(parseInt(btn.getAttribute('data-line'), 10), 0);
        });
      });
    },

    renderFooter: function (cart) {
      var el = document.getElementById('hoa-cart-footer');
      if (!el) return;

      if (!cart.items || cart.items.length === 0) {
        el.innerHTML = '';
        return;
      }

      var subtotal = (cart.total_price / 100).toFixed(2).replace('.', ',');

      el.innerHTML =
        '<div class="hoa-cart-footer__subtotal">' +
          '<span>Zwischensumme</span>' +
          '<span class="hoa-cart-footer__price">' + subtotal + '€</span>' +
        '</div>' +
        '<a href="/checkout" class="hoa-cart-footer__checkout">ZUR KASSE</a>' +
        '<button class="hoa-cart-footer__continue" type="button">Weiter shoppen</button>';

      el.querySelector('.hoa-cart-footer__continue').addEventListener('click', function () {
        CartDrawer.close();
      });
    },

    renderUpsell: function (cart) {
      var el = document.getElementById('hoa-cart-upsell');
      if (!el) return;

      /* Keine Upsells wenn Warenkorb leer */
      if (!cart.items || cart.items.length === 0) {
        el.innerHTML = '';
        return;
      }

      /* Produkt-IDs die schon im Warenkorb sind */
      var cartProductIds = cart.items.map(function (i) { return i.product_id; });
      var firstProductId = cart.items[0].product_id;

      fetch('/recommendations/products.json?product_id=' + firstProductId + '&limit=4')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.products) return;
          /* Filter out products already in cart */
          var recs = data.products.filter(function (p) {
            return cartProductIds.indexOf(p.id) === -1;
          }).slice(0, 2);
          if (recs.length === 0) { el.innerHTML = ''; return; }

          var html = '<div class="hoa-cart-upsell"><p class="hoa-cart-upsell__title">Das könnte dir gefallen</p><div class="hoa-cart-upsell__grid">';
          recs.forEach(function (p) {
            var img = p.featured_image
              ? p.featured_image.replace('_{width}x', '_100x')
              : '';
            var price = ((p.variants[0].price) / 100).toFixed(2).replace('.', ',') + ' €';
            html +=
              '<a class="hoa-cart-upsell-card" href="/products/' + p.handle + '">' +
                (img ? '<img class="hoa-cart-upsell-card__img" src="' + img + '" alt="' + CartDrawer.escape(p.title) + '" loading="lazy">' : '<div class="hoa-cart-upsell-card__img"></div>') +
                '<div class="hoa-cart-upsell-card__body">' +
                  '<p class="hoa-cart-upsell-card__name">' + CartDrawer.escape(p.title) + '</p>' +
                  '<p class="hoa-cart-upsell-card__price">' + price + '</p>' +
                '</div>' +
              '</a>';
          });
          html += '</div></div>';
          el.innerHTML = html;
        })
        .catch(function () { el.innerHTML = ''; });
    },

    /* HTML-Escape für user-generierte Strings im innerHTML */
    escape: function (str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  };

  /* Init */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { CartDrawer.init(); });
  } else {
    CartDrawer.init();
  }

  /* Global verfügbar machen (z.B. für theme.js Drawer-Integration) */
  window.HoaCartDrawer = CartDrawer;

}());
